"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var TextInput = {
  styles: function styles(theme) {
    return {
      input: {
        borderRadius: 4,
        borderColor: theme.colors.baseContrast030,
        "&::placeholder": {
          color: theme.colors.baseContrast050
        },
        "&:focus-visible": {
          boxShadow: "none"
        }
      },
      border: {
        borderRadius: 4
      },
      preAndSuffix: {
        borderColor: theme.colors.baseContrast030
      },
      prefix: {
        borderStartStartRadius: 4,
        borderEndStartRadius: 4
      },
      suffix: {
        borderEndEndRadius: 4,
        borderStartEndRadius: 4
      },
      label: {
        fontSize: 14,
        color: theme.colors.baseContrast085
      },
      hint: {
        fontSize: 12
      },
      icon: {
        "& > svg": {
          fill: theme.colors.baseContrast050
        }
      }
    };
  }
};
var _default = exports.default = TextInput;